/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { Button, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { theme } from "../../theme/theme";
import { Form } from "../../types/Form";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import InputEmail from "../InputEmail/InputEmail";
import InputPassword from "../InputPassword/InputPassword";
import styled from "styled-components";

interface FormLoginType {
    email: string;
    password: string;
}

interface FormLoginProps {
    apiErrors?: string[];
    onLogin?: (email, password) => void;
    push?: (path) => void;
}

type FormLoginState = {
    form: Form<FormLoginType>;
};

const Links = styled.div`
    margin-top: ${theme.spacing.unit * 2}px;
    text-decoration: underline;
    line-height: 2;
`;

export class FormLogin extends React.Component<FormLoginProps, FormLoginState> {

    protected formBuilder: any = null;
    protected form: any = null;

    constructor(props: FormLoginProps) {
        super(props);
        this.formBuilder = new UiFormBuilder<FormLoginType>()
            .addField("email", {
                props: {
                    label: "Email",
                    required: true
                }
            })
            .addField("password", {
                props: {
                    label: "Mot de passe",
                    required: true
                }
            })
            .onChange(this.onChange.bind(this))
            ;

        this.state = {
            form: {
                fields: {},
                errors: [],
                values: {
                    email: "",
                    password: ""
                }
            }
        };
    }

    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        const form = builder.exec(this.state.form);
        this.setState({ form: form });
    }

    public onSubmit(e) {
        e.preventDefault();
        if (this.form.reportValidity() && this.props.onLogin) {
            this.props.onLogin(this.state.form.values.email, this.state.form.values.password);
        }
    }

    public render() {
        if (!this.state) {
            return null;
        }

        const uiForm = this.formBuilder.build(this.state.form);

        return (
            <form ref={(ref) => this.form = ref} onSubmit={this.onSubmit.bind(this)}>
                <Grid container={true} spacing={16}>
                    <Grid item={true} sm={12}>
                        <InputEmail {...uiForm.fields.email} />
                    </Grid>
                    <Grid item={true} sm={12}>
                        <InputPassword {...uiForm.fields.password} />
                    </Grid>
                    <Grid item={true} sm={12} style={{ marginTop: `${theme.spacing.unit * 2}px`, textAlign: "right" }}>
                        <Button type="submit" variant="contained" color="primary" size="large">Connexion</Button>
                        <Links>
                            <Typography variant="caption" style={{cursor: "pointer"}} onClick={() => this._push("/lost-password")}>Mot de passe oublié ?</Typography>
                            <Typography variant="caption" style={{cursor: "pointer"}} onClick={() => this._push("/register")}>Première utilisation ?</Typography>
                        </Links>
                    </Grid>
                </Grid>
            </form>
        );
    }

    private _push(path) {
        if (this.props.push) {
            this.props.push(path);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/FormLogin/FormLogin.tsx